import { render, staticRenderFns } from "./BannerView.vue?vue&type=template&id=115b0e6e&scoped=true&"
import script from "./BannerView.vue?vue&type=script&lang=js&"
export * from "./BannerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b0e6e",
  null
  
)

export default component.exports